import { LogLevel, logMessage } from "@/lib/monitoring/monitoring";
import { useEffect, useRef, useState } from "react";
import { PATIENT_TABS_WARNING_THRESHOLD } from "../constants";
import { PatientTabType } from "../network/usePatientTabs";
import { usePatientTabs } from "../network/usePatientTabs";

export const useTooManyTabsWarning = (): {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
} => {
  const [isOpen, setIsOpen] = useState(false);
  const prevCountRef = useRef<number | null>(null);
  const { data } = usePatientTabs(true);

  const currentCount = data?.patientTabs.filter(
    (t) => t.tabType !== PatientTabType.PREVIEW,
  ).length;

  useEffect(() => {
    if (currentCount === undefined) return;

    const effectivePrev = prevCountRef.current ?? 0;

    if (
      currentCount > PATIENT_TABS_WARNING_THRESHOLD &&
      currentCount > effectivePrev
    ) {
      setIsOpen(true);
      logMessage("Too many patient tabs warning shown", LogLevel.Info, {
        tabCount: currentCount,
      });
    }

    prevCountRef.current = currentCount;
  }, [currentCount]);

  return {
    isOpen,
    onOpenChange: setIsOpen,
  };
};
